import { usePage } from 'client/store'
import pageSelectors from 'client/store/page/pageSelectors'
import EntityTypeEnum from 'common/enums/entityTypeEnum'
import { getAvailableItemsForWebsiteHeader } from '../shared/entities/website-header/utils'

export const useIsAllowedWebsiteHeaderEntity = (
  parentId: string = '',
  entityType: EntityTypeEnum,
): boolean => {
  const isAvailableItem =
    getAvailableItemsForWebsiteHeader().includes(entityType)

  return (
    usePage(page => pageSelectors.getEntityById(page, parentId || ''))?.type ===
      EntityTypeEnum.WebsiteHeader && isAvailableItem
  )
}
